import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pos.revenue');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pos-revenue',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pos.revenue/view.scss */
:host {
  display: block;
  height: 100%;
}

.revenue-screen {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--pos-bg);
  color: var(--pos-text);
  overflow: hidden;
}

.revenue-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: var(--pos-panel);
  border-bottom: 1px solid var(--pos-border);
  flex-shrink: 0;
}
.revenue-header .back-btn {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.revenue-header .back-btn:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}
.revenue-header .page-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}
.revenue-header .tab-badge {
  margin-left: auto;
  padding: 4px 12px;
  border-radius: 12px;
  background: var(--pos-accent);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.tab-nav {
  display: flex;
  gap: 2px;
  padding: 6px 16px;
  background: var(--pos-panel);
  border-bottom: 1px solid var(--pos-border);
  flex-shrink: 0;
  overflow-x: auto;
}
.tab-nav::-webkit-scrollbar {
  height: 0;
}

.tab-btn {
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}
.tab-btn:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}
.tab-btn.active {
  background: var(--pos-accent);
  color: #fff;
  border-color: var(--pos-accent);
  font-weight: 600;
}

.tab-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.tab-pane {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.cond-bar {
  padding: 10px 16px;
  background: var(--pos-panel);
  border-bottom: 1px solid var(--pos-border);
  flex-shrink: 0;
}

.cond-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.cond-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.cond-item label {
  font-size: 12px;
  color: var(--pos-text-dim);
  white-space: nowrap;
  min-width: 44px;
}
.cond-item input, .cond-item select {
  height: 30px;
  padding: 0 8px;
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  background: var(--pos-input-bg, var(--pos-bg));
  color: var(--pos-text);
  font-size: 12px;
  outline: none;
}
.cond-item input:focus, .cond-item select:focus {
  border-color: var(--pos-accent);
}
.cond-item input[type=date] {
  width: 140px;
}
.cond-item input[type=text] {
  width: 100px;
}

.search-btn {
  padding: 6px 18px;
  border-radius: 4px;
  border: none;
  background: var(--pos-accent);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.search-btn:hover {
  background: var(--pos-accent-hover, #2563eb);
}

.radio-group {
  display: flex;
  gap: 12px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 12px;
  color: var(--pos-text);
}
.radio-item input {
  accent-color: var(--pos-accent);
}

.tables-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 16px;
  overflow-y: auto;
  min-height: 0;
}

.table-section {
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 8px;
  overflow: hidden;
}

.table-title {
  margin: 0;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  background: var(--pos-hover);
  border-bottom: 1px solid var(--pos-border);
}

.table-wrap {
  overflow-x: auto;
}

.rv-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.rv-table thead th {
  padding: 7px 8px;
  text-align: center;
  white-space: nowrap;
  background: var(--pos-table-header, var(--pos-bg));
  border-bottom: 1px solid var(--pos-border);
  color: var(--pos-text-dim);
  font-weight: 600;
}
.rv-table tbody td {
  padding: 6px 8px;
  text-align: center;
  border-bottom: 1px solid var(--pos-border);
  border-bottom-color: rgba(128, 128, 128, 0.08);
}
.rv-table tbody tr:hover {
  background: var(--pos-hover);
}
.rv-table tfoot td {
  padding: 7px 8px;
  text-align: center;
  border-top: 2px solid var(--pos-border);
  font-weight: 700;
  background: var(--pos-hover);
}
.rv-table .text-right {
  text-align: right;
}
.rv-table .total-row td {
  font-weight: 700;
  color: var(--pos-accent);
}

.settle-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.settle-actions {
  display: flex;
  gap: 8px;
  padding: 12px 0;
}
.settle-actions .action-btn {
  padding: 8px 18px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  font-size: 13px;
  cursor: pointer;
}
.settle-actions .action-btn:hover {
  background: var(--pos-hover);
}
.settle-actions .primary-btn {
  background: var(--pos-accent);
  color: #fff;
  border-color: var(--pos-accent);
}
.settle-actions .primary-btn:hover {
  background: var(--pos-accent-hover, #2563eb);
}

.dual-tables {
  display: flex;
  gap: 12px;
}

.dual-tables .table-section {
  flex: 1;
  min-width: 0;
}

.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  background: rgba(52, 199, 89, 0.15);
  color: var(--pos-green);
}
.status-badge.refund {
  background: rgba(255, 59, 48, 0.15);
  color: var(--pos-red);
}

.refund-row td {
  opacity: 0.7;
}

.flow-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(52, 199, 89, 0.15);
  color: var(--pos-green);
}
.flow-badge.out {
  background: rgba(255, 59, 48, 0.15);
  color: var(--pos-red);
}

.outflow td {
  color: var(--pos-red);
}

.time-chart-area {
  flex-shrink: 0;
  margin: 12px 16px 0;
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 8px;
  overflow: hidden;
}
.time-chart-area .table-title {
  margin: 0;
}

.time-chart {
  padding: 16px 12px 8px;
  overflow-x: auto;
}

.time-chart-bars {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  height: 180px;
  min-width: 600px;
}

.time-bar-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  min-width: 24px;
}

.time-bar-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.time-bar-value {
  font-size: 9px;
  color: var(--pos-text-dim);
  white-space: nowrap;
  margin-bottom: 2px;
  text-align: center;
}

.time-bar {
  width: 70%;
  min-height: 2px;
  border-radius: 3px 3px 0 0;
  background: rgba(128, 128, 128, 0.15);
  transition: height 0.3s ease;
}
.time-bar.has-value {
  background: var(--pos-accent);
}

.time-bar-label {
  font-size: 10px;
  color: var(--pos-text-dim);
  margin-top: 4px;
  white-space: nowrap;
  text-align: center;
}

.filter-bar {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding: 10px 16px;
  flex-shrink: 0;
}
.filter-bar .filter-btn {
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
  color: var(--pos-text-dim);
  padding: 6px 14px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}
.filter-bar .filter-btn.active {
  background: var(--pos-accent);
  border-color: var(--pos-accent);
  color: #fff;
}
.filter-bar .filter-btn:hover:not(.active) {
  background: var(--pos-hover);
  color: var(--pos-text);
}

.calendar-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: var(--pos-panel);
  border-radius: 8px;
  border: 1px solid var(--pos-border);
  padding: 10px;
  margin: 0 16px 12px;
  overflow: auto;
}

.month-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 6px 0 10px;
}
.month-nav .nav-btn {
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
  color: var(--pos-text-dim);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.month-nav .nav-btn:hover {
  background: var(--pos-hover);
  color: var(--pos-text);
}
.month-nav .month-label {
  font-size: 16px;
  font-weight: 600;
  min-width: 140px;
  text-align: center;
}

.calendar-grid {
  flex: 1;
}
.calendar-grid .cal-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr) 1.3fr;
  border-bottom: 2px solid var(--pos-border);
}
.calendar-grid .cal-header .cal-cell {
  padding: 8px 4px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: var(--pos-text-dim);
}
.calendar-grid .cal-row {
  display: grid;
  grid-template-columns: repeat(7, 1fr) 1.3fr;
  border-bottom: 1px solid var(--pos-border);
  border-bottom-color: rgba(128, 128, 128, 0.1);
}
.calendar-grid .cal-row.totals-row {
  border-top: 2px solid var(--pos-border);
  border-bottom: none;
  background: var(--pos-hover);
}
.calendar-grid .cal-cell {
  padding: 5px 3px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 44px;
}
.calendar-grid .cal-cell .date-num {
  font-size: 11px;
  color: var(--pos-text-dim);
  margin-bottom: 1px;
}
.calendar-grid .cal-cell .amount {
  font-size: 11px;
  color: var(--pos-text);
  font-weight: 500;
}
.calendar-grid .cal-cell .total-label {
  font-size: 10px;
  color: var(--pos-text-dim);
  margin-bottom: 1px;
}
.calendar-grid .day-sun .date-num, .calendar-grid .day-sun .amount {
  color: var(--pos-red) !important;
}
.calendar-grid .day-sat .date-num, .calendar-grid .day-sat .amount {
  color: var(--pos-accent) !important;
}
.calendar-grid .total-col {
  background: var(--pos-selected);
}
.calendar-grid .total-col .amount {
  color: var(--pos-accent) !important;
  font-weight: 600 !important;
}
.calendar-grid .grand-total {
  background: var(--pos-selected);
}
.calendar-grid .grand-total .amount {
  color: var(--pos-text) !important;
  font-weight: 700 !important;
  font-size: 12px !important;
}
.calendar-grid .empty {
  opacity: 0.3;
}`],
})
export class PagePosRevenueComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) {}

    public tabs: string[] = [
        '분류별 매출현황', '상품별 매출현황', '결제수단별 매출현황',
        '할인구분별 매출현황', '월별 매출현황', '정산현황',
        '시간대별 매출현황', '영수증별 매출현황', '상품별 주문 취소 현황',
        '코너별 매출현황', '시재 입출금 현황', '테이블그룹 매출현황',
    ];
    public activeTab: string = '분류별 매출현황';
    private menuActionHandler: any;

    public dateFrom: string = '';
    public dateTo: string = '';
    public posNo: string = '';

    public currentYear: number = new Date().getFullYear();
    public currentMonth: number = new Date().getMonth() + 1;
    public activeFilter: string = '전체';
    public calendarWeeks: any[] = [];
    public dayTotals: number[] = [0, 0, 0, 0, 0, 0, 0];
    public monthTotal: number = 0;
    public salesData: { [key: number]: number } = {};
    public filters: string[] = ['전체', '현금', '신용카드', '외상', '상품권', '식권', '회원포인트', '제휴 사용'];

    public catSummary: any[] = [];
    public catDetail: any[] = [];
    public prodSummary: any[] = [];
    public prodDetail: any[] = [];
    public payViewMode: string = '영수건별';
    public paySummary: any[] = [];
    public payDetail: any[] = [];
    public discSummary: any[] = [];
    public discDetail: any[] = [];
    public settleCash: any[] = [];
    public settleCard: any[] = [];
    public settleCashCalc: any[] = [];
    public settleVoucher: any[] = [];
    public timeSummary: any[] = [];
    public timeDetail: any[] = [];
    public receiptList: any[] = [];
    public cancelSummary: any[] = [];
    public cancelDetail: any[] = [];
    public cornerSummary: any[] = [];
    public cornerDetail: any[] = [];
    public cashFlowList: any[] = [];
    public tgViewMode: string = '일자별';
    public tgDateSummary: any[] = [];
    public tgGroupSummary: any[] = [];
    public tgPaySummary: any[] = [];

    public async ngOnInit() {
        await this.service.init();
        this.menuActionHandler = (e: any) => {
            const action = e.detail?.action;
            if (action && this.tabs.includes(action)) { this.switchTab(action); }
        };
        document.addEventListener('pos-menu-action', this.menuActionHandler);
        this.initDates();
        await this.loadCategorySales();
        await this.loadMonthlySales();
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.menuActionHandler) document.removeEventListener('pos-menu-action', this.menuActionHandler);
    }

    private initDates() {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const d = String(now.getDate()).padStart(2, '0');
        this.dateTo = `${y}-${m}-${d}`;
        this.dateFrom = `${y}-${m}-01`;
    }

    public async switchTab(tab: string) {
        this.activeTab = tab;
        await this.loadTabData(tab);
        await this.service.render();
    }

    private async loadTabData(tab: string) {
        switch (tab) {
            case '분류별 매출현황': await this.loadCategorySales(); break;
            case '상품별 매출현황': await this.loadProductSales(); break;
            case '결제수단별 매출현황': await this.loadPaymentSales(); break;
            case '할인구분별 매출현황': await this.loadDiscountSales(); break;
            case '월별 매출현황': await this.loadMonthlySales(); this.buildCalendar(); break;
            case '정산현황': await this.loadSettlement(); break;
            case '시간대별 매출현황': await this.loadTimeSales(); break;
            case '영수증별 매출현황': await this.loadReceiptSales(); break;
            case '상품별 주문 취소 현황': await this.loadCancelSales(); break;
            case '코너별 매출현황': await this.loadCornerSales(); break;
            case '시재 입출금 현황': await this.loadCashFlow(); break;
            case '테이블그룹 매출현황': await this.loadTableGroupSales(); break;
        }
    }

    public async onSearch() {
        await this.loadTabData(this.activeTab);
        await this.service.render();
    }

    // ─── 분류별 매출현황 ───
    public async loadCategorySales() {
        let res = await wiz.call("category_sales", { dateFrom: this.dateFrom, dateTo: this.dateTo });
        if (res.code === 200) {
            this.catSummary = res.data.summary || [];
            this.catDetail = res.data.detail || [];
        }
    }

    // ─── 상품별 매출현황 ───
    public async loadProductSales() {
        let res = await wiz.call("product_sales", { dateFrom: this.dateFrom, dateTo: this.dateTo });
        if (res.code === 200) {
            this.prodSummary = res.data.summary || [];
            this.prodDetail = res.data.detail || [];
        }
    }

    // ─── 결제수단별 매출현황 ───
    public async loadPaymentSales() {
        let res = await wiz.call("payment_sales", { dateFrom: this.dateFrom, dateTo: this.dateTo });
        if (res.code === 200) {
            this.paySummary = res.data.summary || [];
            this.payDetail = res.data.detail || [];
        }
    }

    public async setPayViewMode(mode: string) { this.payViewMode = mode; await this.service.render(); }

    // ─── 할인구분별 매출현황 ───
    public async loadDiscountSales() {
        let res = await wiz.call("discount_sales", { dateFrom: this.dateFrom, dateTo: this.dateTo });
        if (res.code === 200) {
            this.discSummary = res.data.summary || [];
            this.discDetail = res.data.detail || [];
        }
    }

    // ─── 정산현황 ───
    public async loadSettlement() {
        let res = await wiz.call("settlement", { dateFrom: this.dateFrom, dateTo: this.dateTo });
        if (res.code === 200) {
            this.settleCash = res.data.cash || [];
            this.settleCard = res.data.card || [];
            this.settleCashCalc = res.data.cashCalc || [];
            this.settleVoucher = res.data.voucher || [];
        }
    }

    // ─── 시간대별 매출현황 ───
    public async loadTimeSales() {
        let res = await wiz.call("time_sales", { dateFrom: this.dateFrom, dateTo: this.dateTo });
        if (res.code === 200) {
            this.timeSummary = res.data.summary || [];
            this.timeDetail = res.data.detail || [];
        }
    }

    get timeMaxAmount(): number {
        if (!this.timeSummary.length) return 1;
        return Math.max(...this.timeSummary.map((r: any) => r.amount || 0), 1);
    }

    timeBarPct(amount: number): number {
        return Math.round((amount / this.timeMaxAmount) * 100);
    }

    timeBarLabel(hour: string): string {
        return hour.split('~')[0].replace(':00', '시');
    }

    // ─── 영수증별 매출현황 ───
    public async loadReceiptSales() {
        let res = await wiz.call("receipt_sales", { dateFrom: this.dateFrom, dateTo: this.dateTo });
        if (res.code === 200) {
            this.receiptList = res.data.list || [];
        }
    }

    // ─── 시재 입출금 현황 ───
    public async loadCashFlow() {
        let res = await wiz.call("cash_flow", { dateFrom: this.dateFrom, dateTo: this.dateTo });
        if (res.code === 200) {
            this.cashFlowList = res.data.list || [];
        }
    }

    // ─── 상품별 주문 취소 현황 ───
    public async loadCancelSales() {
        let res = await wiz.call("cancel_sales", { dateFrom: this.dateFrom, dateTo: this.dateTo });
        if (res.code === 200) {
            this.cancelSummary = res.data.summary || [];
            this.cancelDetail = res.data.detail || [];
        }
    }

    // ─── 코너별 매출현황 ───
    public async loadCornerSales() {
        let res = await wiz.call("corner_sales", { dateFrom: this.dateFrom, dateTo: this.dateTo });
        if (res.code === 200) {
            this.cornerSummary = res.data.summary || [];
            this.cornerDetail = res.data.detail || [];
        }
    }

    // ─── 테이블그룹 매출현황 ───
    public async loadTableGroupSales() {
        let res = await wiz.call("table_group_sales", { dateFrom: this.dateFrom, dateTo: this.dateTo });
        if (res.code === 200) {
            this.tgGroupSummary = res.data.summary || [];
        }
    }

    public async setTgViewMode(mode: string) { this.tgViewMode = mode; await this.service.render(); }

    // ─── 월별 매출현황 ───
    public async loadMonthlySales() {
        let res = await wiz.call("monthly_sales", { year: this.currentYear, month: this.currentMonth });
        if (res.code === 200) {
            this.salesData = res.data.data || {};
        } else {
            this.salesData = {};
        }
        this.buildCalendar();
    }

    public buildCalendar() {
        const year = this.currentYear; const month = this.currentMonth - 1;
        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        this.calendarWeeks = []; this.dayTotals = [0,0,0,0,0,0,0]; this.monthTotal = 0;
        let week: any[] = []; let weekTotal = 0;
        for (let i = 0; i < firstDay; i++) week.push({ day: 0, amount: 0 });
        for (let d = 1; d <= daysInMonth; d++) {
            const dow = new Date(year, month, d).getDay();
            const amount = this.salesData[d] || 0;
            week.push({ day: d, amount }); weekTotal += amount;
            this.dayTotals[dow] += amount; this.monthTotal += amount;
            if (dow === 6 || d === daysInMonth) {
                while (week.length < 7) week.push({ day: 0, amount: 0 });
                this.calendarWeeks.push({ days: week, total: weekTotal });
                week = []; weekTotal = 0;
            }
        }
    }

    public async prevMonth() {
        this.currentMonth--; if (this.currentMonth < 1) { this.currentMonth = 12; this.currentYear--; }
        await this.loadMonthlySales(); await this.service.render();
    }

    public async nextMonth() {
        this.currentMonth++; if (this.currentMonth > 12) { this.currentMonth = 1; this.currentYear++; }
        await this.loadMonthlySales(); await this.service.render();
    }

    public async setFilter(filter: string) {
        this.activeFilter = filter; await this.loadMonthlySales(); await this.service.render();
    }

    public sumField(arr: any[], field: string): number {
        return arr.reduce((s: number, r: any) => s + (Number(r[field]) || 0), 0);
    }

    public formatAmount(amount: number): string {
        if (!amount || amount === 0) return '';
        return Number(amount).toLocaleString();
    }

    public formatCurrency(v: number): string {
        return (v || 0).toLocaleString();
    }

    public goBack() { this.service.href('/pos'); }
}

export default PagePosRevenueComponent;